<template>
  <div class="productpoolgood-list">
    <Row>
      <Col :xs="24"
           :sm="24">
      <Form :model="formItem"
            ref="formItem"
            :inline="true"
            action="javascript:void(0)">
        <FormItem>
          <Select v-model="formItem.type"
                  clearable
                  filterable
                  placeholder="选择类型">
            <Option value="0">商品</Option>
            <Option value="1">材料</Option>
          </Select>
        </FormItem>
        <FormItem>
          <Select v-model="formItem.is_chouqu"
                  clearable
                  placeholder="能否抽取">
            <Option v-for="item in statusList"
                    :value="item.id"
                    :key="item.id">{{ item.name }}</Option>
          </Select>
        </FormItem>
        <FormItem>
          <Select v-model="formItem.good_attr_id"
                  filterable
                  clearable>
            <Option v-for="item in attrList"
                    :value="item.id"
                    :key="item.id">{{ item.title }}</Option>
          </Select>
        </FormItem>
        <FormItem>
          <Button type="primary"
                  @click="renderTable(1)">查找</Button>
        </FormItem>
        <FormItem>
          <Button @click="showModel()"
                  type="success"
                  class="f-l">添加</Button>
        </FormItem>
      </Form>
      </Col>
    </Row>
    <Table border
           :columns="list"
           :data="tablelist"
           :loading="dataloading"></Table>
    <div style="margin: 10px;overflow: hidden">
      <div style="float: right;">
        <Page ref="listPage"
              :total="pages.total"
              :current="pages.page"
              :page-size="pages.size"
              show-elevator
              show-total
              @on-change="changePage()"></Page>
      </div>
    </div>
    <Drawer :title="title"
            v-model="showModalStatus"
            width="50%"
            :mask-closable="false"
            :styles="styles">
      <!-- <Tabs> -->
      <Form :model="goods"
            :label-width="80"
            ref="goodsValidate"
            :rules="goodsValidate">
        <Row>
          <Col span="8">
          <FormItem label="选择分类"
                    label-position="top">
            <Select v-model="goods.pool_cate_id"
                    clearable
                    filterable
                    placeholder="选择分类">
              <Option v-for="item in poolCateList"
                      :value="item.id"
                      :key="item.id">{{item.title}}</Option>
            </Select>
          </FormItem>
          </Col>
          <Col span="8">
          <FormItem label="类型">
            <Select v-model="goods.type"
                    clearable
                    filterable
                    placeholder="选择类型"
                    @on-change="goodtypestatus">
              <Option :value="0">商品</Option>
              <Option :value="1">材料</Option>
            </Select>
          </FormItem>
          </Col>

          <Col span="8">
          <FormItem label="属性标签"
                    label-position="top">
            <Select v-model="goods.attrtag_id"
                    clearable
                    filterable
                    placeholder="选择标签">
              <Option v-for="item in tagList"
                      :value="item.id"
                      :key="item.id">{{item.title}}</Option>
            </Select>
          </FormItem>
          </Col>

        </Row>
        <Row>
          <Col span="8">
          <FormItem label="排序"
                    label-position="top">
            <Input v-model="goods.sort"></Input>
          </FormItem>
          </Col>
          <Col span="8">
          <FormItem label="抽取">
            <RadioGroup v-model="goods.is_chouqu">
              <Radio label="0">不支持</Radio>
              <Radio label="1">支持</Radio>
            </RadioGroup>
          </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span="24">
          <FormItem label="选择商品"
                    label-position="top"
                    v-if="goods.type==0">
            <Select v-model="goods.good_id"
                    clearable
                    filterable
                    placeholder="选择商品"
                    @on-query-change="searchGoods"
                    @on-change="selectGood">
              <Option v-for="item in goodtablelist"
                      :value="item.good_id"
                      :disabled="item.disabled"
                      :key="item.good_id">{{item.good_title}}</Option>
            </Select>
          </FormItem>
          <FormItem label="选择材料"
                    label-position="top"
                    v-else-if="goods.type==1">
            <Select v-model="goods.good_id"
                    clearable
                    filterable
                    placeholder="选择材料"
                    @on-change="selectData">
              <Option v-for="item in datatablelist"
                      :value="item.good_id"
                      :disabled="item.disabled"
                      :key="item.good_id">{{item.good_title}}</Option>
            </Select>
          </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span="12">
          <FormItem label="库存"
                    label-position="top"
                    prop="store">
            <Input v-model="goods.store"></Input>
          </FormItem>
          </Col>
          <Col span="12">
          <FormItem label="属性"
                    label-position="top"
                    prop="good_attr">
            <Select v-model="goods.good_attr_id"
                    filterable
                    clearable>
              <Option v-for="item in attrList"
                      :value="item.id"
                      :key="item.id">{{ item.title }}</Option>
            </Select>
          </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span="12">
          <FormItem label="采购单价"
                    label-position="top"
                    prop="buy_price">
            <Input v-model="goods.buy_price"></Input>
          </FormItem>
          </Col>
          <Col span="12">
          <FormItem label="商品单价"
                    label-position="top">
            <Input v-model="goods.good_price"></Input>
          </FormItem>
          </Col>
          <Col span="12">
          <FormItem label="标题"
                    label-position="top">
            <Input v-model="goods.title"></Input>
          </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span="24">
          <FormItem label="缩略图"
                    prop="thumb">
            <upload-thumb v-model="goods.thumb"
                          ref="uploadthumb"
                          :defaultList="thumblist"
                          :autoCropWidth="400"
                          :autoCropHeight="400"
                          :defaultTip="'图片格式:jpg、jpeg、png、gif,建议图片尺寸:400*400,大小不超过2M'"></upload-thumb>
          </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span="12">
          <FormItem label="商品链接">
            <Input v-model="goods.good_url"></Input>
          </FormItem>
          </Col>
          <Col span="12">
          <FormItem label="供应商名称"
                    v-if="showGoodUrl">
            <Input v-model="goods.seller_name"
                   readonly></Input>
          </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span="24">
          <FormItem label="描述"
                    label-position="top">
            <Input type="textarea"
                   v-model="goods.describe"
                   :rows="3"
                   placeholder="请输入描述" />
          </FormItem>
          </Col>
        </Row>
        <!-- <Row>
          <Col span="25">
            <FormItem label="内容">
              <UEditor v-model="goods.content" ref="editContent"></UEditor>
            </FormItem>
          </Col>
        </Row>-->
      </Form>
      <!-- </Tabs> -->
      <div class="demo-drawer-footer">
        <Button style="margin-right: 8px"
                @click="showModalStatus = false">取消</Button>
        <Button type="primary"
                @click="creategoods('goodsValidate')"
                :loading="loading">提交</Button>
      </div>
    </Drawer>
  </div>
</template>

<script>
import UploadThumb from "../../common/thumb";
import UEditor from "../../common/ueditor";

export default {
  name: "productpoolgood-list",
  data () {
    const validateThumb = (rule, value, callback) => {
      if (this.$refs["uploadthumb"].uploadList.length == 0) {
        callback(new Error("请上传缩略图"));
      } else {
        callback();
      }
    };
    const validateSelectAttr = (rule, value, callback) => {
      if (
        this.goods.good_attr_id == "" ||
        this.goods.good_attr_id == null ||
        this.goods.good_attr_id == undefined
      ) {
        callback(new Error("请选择商品属性"));
      } else {
        callback();
      }
    };
    const validateStore = (rule, value, callback) => {
      if (
        this.goods.store == "" ||
        this.goods.store == null ||
        this.goods.store == undefined
      ) {
        callback(new Error("请填写库存"));
      } else {
        callback();
      }
    };
    return {
      styles: {
        height: "calc(100% - 55px)",
        overflow: "auto",
        paddingBottom: "53px",
        position: "static"
      },
      attrList: [],
      goods: {
        good: {
          id: null
        },
        is_chouqu: "0",
        type: "0",
        sort: "0",
        good_url: ""
      },
      isable: true,
      showGoodUrl: true,
      loading: false,
      dataloading: true,
      thumblist: [],
      tagList: [],
      poolCateList: [],
      pages: {
        page: 1,
        size: 10,
        total: 0
      },
      title: "",
      formItem: {
        type: ""
      },
      statusList: [
        { id: 0, name: "否" },
        { id: 1, name: "是" }
      ],
      list: [
        {
          title: "Id",
          key: "id",
          fixed: "left",
          width: 90
        },
        {
          title: "标题",
          key: "title",
          minWidth: 200
        },
        {
          title: "可抽取",
          key: "is_chouqu",
          minWidth: 200
        },
        {
          title: "供应商",
          key: "seller_name",
          minWidth: 200
        },
        {
          title: "类型",
          key: "type",
          minWidth: 80
        },
        {
          title: "属性",
          key: "attr",
          minWidth: 80
        },
        {
          title: "属性标签",
          key: "attrtagname",
          minWidth: 80
        },
        {
          title: "库存",
          key: "store",
          minWidth: 80
        },
        {
          title: "销量",
          key: "sale",
          minWidth: 80
        },
        {
          title: "采购单价",
          key: "buy_price",
          minWidth: 80
        },
        {
          title: "排序",
          key: "sort",
          minWidth: 80
        },
        {
          title: "操作",
          key: "action",
          width: 200,
          align: "left",
          fixed: "right",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  style: {
                    marginRight: "8px"
                  },
                  props: {
                    type: "primary",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.detail(params.row.id);
                    }
                  }
                },
                "编辑"
              ),
              h(
                "Button",
                {
                  style: {
                    marginRight: "8px"
                  },
                  props: {
                    type: "error",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.remove(params.row.id);
                    }
                  }
                },
                "删除"
              )
            ]);
          }
        }
      ],
      tablelist: [],
      goodtablelist: [],
      datatablelist: [],
      // good_type: 0,
      showModalStatus: false,
      goodsValidate: {
        // sort: [{ required: true, message: "排序必须填写", trigger: "blur" }],
        store: [{ required: true, validator: validateStore, trigger: "blur" }],
        good_attr: [
          { required: true, validator: validateSelectAttr, trigger: "change" }
        ],
        // buy_price: [
        //   { required: true, message: "采购单价必须填写", trigger: "blur" }
        // ]
        thumb: [
          { required: true, validator: validateThumb, trigger: "change" }
        ],
      },
      id: 0
    };
  },
  created: function () {
    this.pool_id = this.$route.params.pool_id;
    this.getTableList();
    this.getAttr();
    this.getGoodList();
    this.getDataList();
  },
  components: {
    UploadThumb,
    UEditor
  },

  methods: {
    getTableList: function () {
      this.$api.productpoolgood
        .list({
          pool_id: this.pool_id,
          page: this.pages.page,
          size: this.pages.size
        })
        .then(res => {
          this.dataloading = false;
          if (res.code == 200) {
            this.tablelist = res.result.list;
            this.pages.total = res.result.total;
            this.$Message.success(res.msg);
            // 同步筛选条件
            this.renderTable();
          }
        });
      return;
    },
    getAttrTagList () {
      this.$api.goodattrtag.list({
        page: 1,
        size: 50
      }).then(res => {
        if (res.code == 200) {
          this.tagList = res.result.list;
        }
      });
    },
    getPoolCateList () {
      this.$api.productpoolcate.list({
        pool_id: this.pool_id,
        page: 1,
        size: 50
      }).then(res => {
        if (res.code == 200) {
          this.poolCateList = res.result.list;
        }
      });
    },
    // 获取属性
    getAttr: function () {
      this.$api.productpoolgood.attrs({ pool_id: this.pool_id }).then(res => {
        if (res.code == 200) {
          this.attrList = res.result;
        }
      });
      return;
    },
    // 切换产品池展示形式
    goodtypestatus: function (val) {
      // 返回的是 lable值
      this.goods.good_id = null;
      this.goods.title = null;
      this.goods.describe = null;
      this.goods.good_url = null;
      if (val == 0) {
        this.showGoodUrl = true;
      } else if (val == 1) {
        this.showGoodUrl = false;
      }
    },
    // 选中商品时时
    selectGood (data) {
      this.thumblist = new Array();
      if (data == null || data == undefined || data == "") {
        return;
      }
      this.$api.goods.detail({ good_id: data }).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.goods.title = res.result.title;
          this.goods.describe = res.result.describe;
          this.goods.good_price = res.result.prices;
          this.goods.good_url =
            this.$publicData.H5Url + "/shop/detail?goodsId=" + data;
          this.goods.seller_name = res.result.seller_name;
        }
      });
    },
    selectData (data) {
      this.thumblist = new Array();
      if (data == null || data == undefined || data == "") {
        return;
      }
      this.$api.data.detail({ id: data }).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          console.log(res.result);
          this.goods.title = res.result.name;
          this.goods.describe = res.result.describe;
          this.goods.good_price = res.result.prices;
          this.goods.good_url = "";
          this.thumblist.push({
            name: res.result.thumb,
            url: res.result.thumb,
            status: "finished"
          });
          console.log(this.goods);
          // this.$refs["editContent"].message = "";
        }
      });
    },
    searchGoods (key) {
      console.log("searchGoods:", key);
      if (this.isNumber(key)) {
        key = this.goods.good.title;
      }
      console.log("searchGoods2:", key);
      this.getGoodList(key);
    },
    isNumber (val) {
      var regPos = /^\d+(\.\d+)?$/; //非负浮点数
      var regNeg = /^(-(([0-9]+\.[0-9]*[1-9][0-9]*)|([0-9]*[1-9][0-9]*\.[0-9]+)|([0-9]*[1-9][0-9]*)))$/; //负浮点数
      if (regPos.test(val) || regNeg.test(val)) {
        return true;
      } else {
        return false;
      }
    },
    searchData (key) {
      console.log("searchData:", key);
      this.getDataList(key);
    },
    //搜索匠人
    searchGoods: function (index) {
      this.$api.goods.list({ page: 1, size: 10, is_platprice: "1", key: index }).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          var list = res.result.list;
          for (let i = 0; i < list.length; i++) {
            const goods = list[i];
            goods.disabled = false;
            if (goods.good_title.length > 31) {
              goods.good_title = goods.good_title.slice(0, 30) + "...";
            }
          }
        }
        this.goodtablelist = list;
      });
    },
    //获取商品
    getGoodList: function (key) {
      var params = {
        page: 1,
        size: 10,
        is_platprice: "1"
      };
      if (key && key != undefined && key != "") {
        params.key = key;
      }
      this.$api.goods.list(params).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          var list = res.result.list;
          for (let i = 0; i < list.length; i++) {
            const goods = list[i];
            goods.disabled = false;
            if (goods.good_title.length > 31) {
              goods.good_title = goods.good_title.slice(0, 30) + "...";
            }
            // for (let j = 0; j < this.tablelist.length; j++) {
            //   const selectGoods = this.tablelist[j];
            //   if (
            //     this.goods.good_id != selectGoods.good_id &&
            //     selectGoods.good_id == goods.good_id &&
            //     selectGoods.type == "商品"
            //   ) {
            //     goods.disabled = true;
            //     break;
            //   }
            // }
          }
        }
        this.goodtablelist = list;
      });
      return;
    },
    //获取材料
    getDataList: function (key) {
      var params = {
        page: 1,
        size: 20
      };
      if (key && key != undefined && key != "") {
        params.key = key;
      }
      this.$api.data.list(params).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          var list = res.result.list;
          for (let i = 0; i < list.length; i++) {
            const goods = list[i];
            goods.disabled = false;
            for (let j = 0; j < this.tablelist.length; j++) {
              const selectGoods = this.tablelist[j];
              if (
                selectGoods.good_id == goods.good_id &&
                selectGoods.type == "材料"
              ) {
                goods.disabled = true;
                break;
              }
            }
          }
          // this.goodtablelist = list;
        }
        this.datatablelist = list;
      });
      return;
    },
    // 展开添加
    showModel () {
      this.getPoolCateList();
      this.getAttrTagList();
      this.title = "添加商品";
      this.isBlockGoods = false;
      this.goods = {
        thumb: "",
        good_attr_id: "",
        pool_cate_id: "",
        good_url: "",
        type: 0,
        is_chouqu: "0",
        content: "",
        sort: "0"
      };
      this.isable = true;
      this.loading = false;
      this.thumblist = new Array();
      this.$refs["goodsValidate"].resetFields();
      this.showModalStatus = !this.showModalStatus;
    },
    // 详情
    detail (id) {
      this.getAttrTagList();
      this.getPoolCateList();
      this.title = "编辑商品";
      this.thumblist = new Array();
      this.$refs["goodsValidate"].resetFields();
      this.showModalStatus = true;
      this.goods = {};
      this.$api.productpoolgood.detail({ id: id }).then(res => {
        var goods = res.result;
        if (goods.thumb != null && goods.thumb != "") {
          this.thumblist.push({
            name: goods.thumb,
            url: goods.thumb,
            status: "finished"
          });
        }
        if (goods.type == 0) {
          this.showGoodUrl = true;
        } else {
          this.showGoodUrl = false;
        }
        this.goods = goods;
        this.goods.is_chouqu = goods.is_chouqu.toString();
      });
    },
    // 添加
    creategoods (name) {
      var that = this;
      this.$refs[name].validate(valid => {
        if (valid) {
          // this.goods.content = this.$refs["editContent"].message;
          if (that.$refs["uploadthumb"].uploadList.length > 0) {
            that.goods.thumb = that.$refs["uploadthumb"].uploadList[0].url;
          } else {
            that.goods.thumb = null;
          }
          that.goods.pool_id = this.pool_id;
          that.loading = true;
          if (
            that.goods.id == null ||
            that.goods.id == 0 ||
            that.goods.id == undefined
          ) {
            //新建商品
            that.$api.productpoolgood.create(that.goods).then(res => {
              if (res.code == 200) {
                that.getTableList();
                that.showModalStatus = false;
                this.getGoodList();
                this.getDataList();
              }
              that.goods.id = null;
              that.loading = false;
              // that.$nextTick(() => {
              //   that.loading = true;
              // });
            });
          } else {
            //编辑商品
            that.$api.productpoolgood.edit(that.goods).then(res => {
              if (res.code == 200) {
                that.getTableList();
                that.showModalStatus = false;
                this.getGoodList();
                this.getDataList();
              }
              that.loading = false;
              // that.$nextTick(() => {
              //   that.loading = true;
              // });
            });
          }
        } else {
          that.$Message.error("请检查输入的信息是否正确！");
          that.$nextTick(() => {
            that.loading = false;
          });
        }
      });
    },
    // 删除
    remove: function (id) {
      // 弹出确认框
      this.$Modal.confirm({
        title: "警告",
        content: "<p>此操作不可恢复，三思而后行...</p>",
        onOk: () => {
          this.$api.productpoolgood.remove({ id: id }).then(res => {
            if (res.code == 200) {
              this.$Message.success(res.msg);
              this.getTableList(1);
              this.getGoodList();
              this.getDataList();
            }
          });
        }
      });
    },
    // 翻页
    changePage () {
      this.pages.page = this.$refs["listPage"].currentPage;
      this.renderTable();
    },
    // 筛选
    renderTable: function (name) {
      if (name == 1) {
        this.pages.page = 1;
      }
      this.dataloading = true;
      var ps = {
        pool_id: this.pool_id,
        is_chouqu: this.formItem.is_chouqu,
        type: this.formItem.type,
        good_attr_id: this.formItem.good_attr_id,
        page: this.pages.page,
        size: this.pages.size
      };
      this.$api.productpoolgood.list(ps).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.tablelist = res.result.list;
          this.pages.total = res.result.total;
          this.$Message.success(res.msg);
        }
      });
      return;
    }
  }
};
</script>

<style>
.demo-drawer-footer {
  width: 100%;
  height: 50px;
  position: absolute;
  bottom: 0;
  left: 0;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: right;
  background: #fff;
}
</style>

